<script setup>
import {reactive, ref, nextTick} from "vue";
import Editor from "@tinymce/tinymce-vue";
import PrimaryButton from "@/components/ui/PrimaryButton.vue";

const emit = defineEmits(['saved', 'closed']);

const template = reactive({
    subject: "",
    body: "",
});

const showModal = ref(false);
const showEditor = ref(false);

function open(initTemplate) {
    showModal.value = true;
    template.subject = initTemplate.subject;
    template.body = initTemplate.body;

    nextTick(() => {
        showEditor.value = true;
    });
}

function save() {
    emit('saved', template);
    showModal.value = false;
}

defineExpose({
    open
});
</script>

<template>
    <Modal v-model="showModal" title="Edit Email Template" modal-class="modal-w-md" @hide="emit('closed')">
        <div class="form form-modal mb-4">
            Subject
            <input type="text" class="form-control form-control--mid" v-model="template.subject"/>
        </div>

        <div class="form form-modal mb-4">
            Message
            <Editor
                v-if="showEditor"
                v-model="template.body"
                :apiKey="apiKeys.tinyMCE"
                :init="defaults.editorOptions"
            />
        </div>

        <template #modal-footer>
            <PrimaryButton
                @click="save"
            />
        </template>
    </Modal>
</template>

<style scoped>

</style>
